import { createUseStyles } from 'react-jss'
import { config, getMainColor, boldFont, textSize } from '@portal/kit/pkg/styles'

export default createUseStyles(theme => ({
  selectedOffer: {
    margin: '0 -16px 24px -16px',
    padding: '16px 14px',
    backgroundColor: getMainColor(theme).alpha(.12).rgb().toString(),
    color: theme.main_color,
  },
  selectedOfferWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  offerName: {
    ...boldFont(),
    ...textSize(16, 19),
  },
  offerDescription: {
    paddingTop: 8,
    marginTop: 2,
    ...textSize(14, 16),
  },
  offerPrice: {
    ...boldFont(),
    whiteSpace: 'nowrap',
  },
  catalogName: {
    marginBottom: 4,
    ...textSize(13, 15),
  },
  offerDetailedPrice: {
    paddingTop: 16,
    textAlign: 'right',
    ...textSize(16, 21),

    '& strong': {
      ...boldFont(),
      ...textSize(18, 21),
    }
  },

  [config.mediaQueries.tabletPortrait]: {
    selectedOffer: {
      margin: '0 0 24px 0',
      borderRadius: 4,
    },
  }
}))
